import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import reducer from "./reducers";
import thunk, { ThunkAction } from "redux-thunk";
import { ChannelAction, testActionType } from "../common";

// 创建仓库
// createStore(reducer  init RootState,中间件)
const store = createStore(reducer, composeWithDevTools(applyMiddleware(thunk)));

export type RootState = ReturnType<typeof store.getState>;

export type RootAction = testActionType | ChannelAction;
export type RootThunkAction = ThunkAction<void, RootState, unknown, RootAction>;
export default store;
